import { isDefined, measuremodemultiviewicon } from "../../infra3d";
import { Obj, GEOFRAMETYPE, MEASUREMODE } from "../internal";
import { USERINPUTTYPE } from "../userinput/internal";
import { STREAMTYPE } from "./internal";
import { StereoGeoFrameCollection } from "..";
/**
 * Measure Handler
 * @class MeasureModeHandler
 * @author Benjamin Loesch
 * @extends {Obj}
 *
 */
export class MeasureModeHandler extends Obj {
    constructor(scene) {
        super();
        this.measuremodeindicatorcanvas = null;
        this.mouseindicator = null;
        //minimal standard settings
        this.measureModeOptions = {
            PERSPECTIVE_MONO: ["MONOPLOTTING"],
            PERSPECTIVE_LEFT_DEPTH: ["MONOPLOTTING"],
            PERSPECTIVE_LEFT_RIGHT_DEPTH: ["MONOPLOTTING"],
            PERSPECTIVE_LEFT_RIGHT: ["LEFTRIGHT"],
            PERSPECTIVE_RIGHT_DEPTH: ["MONOPLOTTING"],
            PANO_ALL_MONO: ["PANODEPTHMAPINTERSECTION"],
            PANO_ALL_DEPTH: ["MONOPLOTTING"],
            MULTIPERSPECTIVE_ALL_MONO: [],
            MULTIPERSPECTIVE_ALL_DEPTH: ["MONOPLOTTING"],
        };
        this.scene = scene;
        this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.GEOFRAMECOLLECTIONCHANGED, (geoframecollection) => {
            this.ongeoframecollectionchanged(geoframecollection);
        }, this);
        this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.MOUSEMOVE, (stream) => {
            this.onmousemove(stream);
        }, this);
        this.measuremodeindicatorcanvas = document.createElement("canvas");
        this.measuremodeindicatorcanvas.style.width = "200px";
        this.measuremodeindicatorcanvas.style.height = "50px";
        this.measuremodeindicatorcanvas.width = 200;
        this.measuremodeindicatorcanvas.height = 50;
        this.measuremodeindicatorcanvas.style.position = "absolute";
        this.measuremodeindicatorcanvas.style.left = "0px";
        this.measuremodeindicatorcanvas.style.bottom = "35px";
        this.measuremodeindicatorcanvas.style.pointerEvents = "None";
        this.scene.engine.getCanvas().parentElement.appendChild(this.measuremodeindicatorcanvas);
        this.mouseindicator = document.createElement("canvas");
        this.mouseindicator.style.width = "15px";
        this.mouseindicator.style.height = "15px";
        this.mouseindicator.width = 15;
        this.mouseindicator.height = 15;
        this.mouseindicator.style.position = "absolute";
        this.mouseindicator.style.backgroundImage =
            "url(data:image/png;base64,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)";
        this.mouseindicator.style.margin = "-20px 10px";
        this.mouseindicator.style.backgroundSize = "contain";
        this.mouseindicator.style.pointerEvents = "None";
        this.scene.engine.getCanvas().parentElement.appendChild(this.mouseindicator);
        this.hideMeasureModeCursor();
    }
    setMeasureModeOptions(options) {
        // parse options
        // PANODEPTHMAPINTERSECTION_MULTIVIEW_COMBINED should be removed and replaced by PANODEPTHMAPINTERSECTION_PANO_TWO_CLICK_COMBINED.
        // MeasureModes can not be extended since there's no check of possible measuremodes in sdk release 3.9.0
        const parsed_options = {};
        for (const key in options) {
            parsed_options[key] = [];
            for (const key_measuremode in options[key]) {
                const measuremode = options[key][key_measuremode];
                if (measuremode === "PANODEPTHMAPINTERSECTION_MULTIVIEW_COMBINED") {
                    console.log("Measuremode PANODEPTHMAPINTERSECTION_MULTIVIEW_COMBINED is depricated. " +
                        "Switched to measuremode PANODEPTHMAPINTERSECTION_PANO_TWO_CLICK_COMBINED");
                    parsed_options[key].push("PANODEPTHMAPINTERSECTION_PANO_TWO_CLICK_COMBINED");
                }
                else {
                    parsed_options[key].push(measuremode);
                }
            }
        }
        //default measure options are not overwritten if they are not set in options.
        Object.assign(this.measureModeOptions, parsed_options);
    }
    getMeasureMode() {
        return this.measureMode;
    }
    getMouseMoveMeasureMode() {
        return this.mouseMoveMeasureMode;
    }
    setMeasureMode(mmode) {
        this.measureMode = mmode;
        this.scene.userInputHandler.handleMeasureModeChangedEvent(mmode);
    }
    setMouseMoveMeasureMode(mmode) {
        this.mouseMoveMeasureMode = mmode;
    }
    setOverrideMeasureMode(measureMode) {
        if (this.overrideMeasureMode != null) {
            this.resetOverrideMeasureMode();
        }
        this.overrideMeasureMode = measureMode;
        this.measureMode = measureMode;
        this.updateMeasureModeIndicator();
        this.scene.userInputHandler.handleMeasureModeChangedEvent(measureMode);
    }
    resetOverrideMeasureMode() {
        this.overrideMeasureMode = null;
        this.ongeoframecollectionchanged(this.scene.getCurrentGeoFrameCollection());
    }
    ongeoframecollectionchanged(geoframecollection) {
        this.geoframeType = this.determineGeoframeType(geoframecollection);
        this.determineMeasureMode(this.geoframeType);
        this.updateMeasureModeIndicator();
    }
    determineMeasureMode(frametype) {
        let measuremodeoptions = this.measureModeOptions[GEOFRAMETYPE[frametype]];
        if (!measuremodeoptions)
            measuremodeoptions = [];
        this.possibleMeasureModes = [];
        for (let i = 0; i < measuremodeoptions.length; i++) {
            // check if measure mode exists. if not fallback to the next configured measuremode. this makes it possible
            // to extend measure modes in future releases.
            if (isDefined(MEASUREMODE[measuremodeoptions[i]])) {
                this.possibleMeasureModes.push(parseInt(MEASUREMODE[measuremodeoptions[i]]));
            }
        }
        if (this.overrideMeasureMode == null) {
            let throwevent = false;
            //check if a measuremodechange is nescesarry
            if (this.measureMode != this.possibleMeasureModes[0]) {
                throwevent = true;
            }
            if (this.possibleMeasureModes.length > 0) {
                this.measureMode = this.possibleMeasureModes[0];
            }
            else {
                this.measureMode = MEASUREMODE.NONE;
                this.mouseMoveMeasureMode = MEASUREMODE.NONE;
            }
            this.scene.getMeasureHandler().abortMeasureSequence();
            if (throwevent || this.measureMode == MEASUREMODE.NONE) {
                this.scene.userInputHandler.handleMeasureModeChangedEvent(this.measureMode);
            }
            if (this.possibleMeasureModes.indexOf(MEASUREMODE.MONOPLOTTING) > -1) {
                this.mouseMoveMeasureMode = MEASUREMODE.MONOPLOTTING;
            }
            else if (this.possibleMeasureModes.indexOf(MEASUREMODE.PANODEPTHMAPINTERSECTION) > -1 ||
                this.possibleMeasureModes.indexOf(MEASUREMODE.PANODEPTHMAPINTERSECTION_MULTIVIEW_COMBINED) > -1 ||
                this.possibleMeasureModes.indexOf(MEASUREMODE.PANODEPTHMAPINTERSECTION_PANO_TWO_CLICK_COMBINED) > -1) {
                this.mouseMoveMeasureMode = MEASUREMODE.PANODEPTHMAPINTERSECTION;
            }
            else if (this.measureMode == MEASUREMODE.MONOAPPROXIMATION) {
                this.mouseMoveMeasureMode = MEASUREMODE.MONOAPPROXIMATION;
            }
            else {
                this.mouseMoveMeasureMode = MEASUREMODE.NONE;
            }
        }
        else {
            if (this.possibleMeasureModes.indexOf(this.overrideMeasureMode) == -1) {
                // this means the current override measuremode is not possible with this geoframe
                // we need to reset it
                this.resetOverrideMeasureMode();
            }
            this.mouseMoveMeasureMode = MEASUREMODE.NONE;
        }
    }
    determineGeoframeType(geoframecollection) {
        const mi = geoframecollection.geoframearray[0].getMeasureInfo();
        const imgstructure = mi.imagemeta.structure.toLowerCase();
        const dmstructure = mi.depthmapmeta.structure.toLowerCase();
        const proj = mi.streamtype;
        let geoframetype;
        if (proj == STREAMTYPE.MONO && dmstructure == "none") {
            geoframetype = GEOFRAMETYPE.PERSPECTIVE_MONO;
        }
        else if (proj == STREAMTYPE.MONO && dmstructure == "l") {
            geoframetype = GEOFRAMETYPE.PERSPECTIVE_LEFT_DEPTH;
        }
        else if (proj == STREAMTYPE.STEREO && dmstructure == "l") {
            geoframetype = GEOFRAMETYPE.PERSPECTIVE_LEFT_RIGHT_DEPTH;
        }
        else if (proj == STREAMTYPE.STEREO && dmstructure == "none") {
            geoframetype = GEOFRAMETYPE.PERSPECTIVE_LEFT_RIGHT;
        }
        else if (proj == STREAMTYPE.CALOTTE && dmstructure == "none") {
            geoframetype = GEOFRAMETYPE.PANO_ALL_MONO;
        }
        else if (proj == STREAMTYPE.CALOTTE && dmstructure == "all") {
            geoframetype = GEOFRAMETYPE.PANO_ALL_DEPTH;
        }
        else if (proj == STREAMTYPE.CUBEMAP && dmstructure == "all") {
            geoframetype = GEOFRAMETYPE.MULTIPERSPECTIVE_ALL_DEPTH;
        }
        else if (proj == STREAMTYPE.CUBEMAP && dmstructure == "none") {
            geoframetype = GEOFRAMETYPE.MULTIPERSPECTIVE_ALL_MONO;
        }
        else {
            console.warn("infra3D Error: Invalid measuremode configuration");
            geoframetype = GEOFRAMETYPE.UNKNOWN;
        }
        return geoframetype;
    }
    updateMeasureModeIndicator() {
        const ctx = this.measuremodeindicatorcanvas.getContext("2d");
        ctx.clearRect(0, 0, this.measuremodeindicatorcanvas.width, this.measuremodeindicatorcanvas.height);
        ctx.font = "16px Arial";
        ctx.fillStyle = "#FFFFFF";
        ctx.shadowColor = "black";
        ctx.shadowOffsetX = 1;
        ctx.shadowOffsetY = 1;
        ctx.shadowBlur = 4;
        const geoframecollection = this.scene.getCurrentGeoFrameCollection();
        if (geoframecollection instanceof StereoGeoFrameCollection)
            geoframecollection.hideImageSideIndicator();
        switch (this.getMeasureMode()) {
            case MEASUREMODE.LEFTRIGHT:
                //do nothing stereostreams handles visibikity
                this.scene.getCurrentGeoFrameCollection().showImageSideIndicator();
                break;
            case MEASUREMODE.MULTIVIEW: {
                const img = new Image();
                img.src = measuremodemultiviewicon;
                this.measuremodeindicatorcanvas.style.display = "block";
                ctx.clearRect(0, 0, 200, 50);
                img.onload = () => {
                    ctx.drawImage(img, 10, 10, 40, 30);
                };
                break;
            }
        }
    }
    showMeasureModeCursor() {
        this.mouseindicator.style.visibility = "visible";
    }
    hideMeasureModeCursor() {
        this.mouseindicator.style.visibility = "hidden";
    }
    onmousemove(evt) {
        this.mouseindicator.style.left = evt.offsetX + "px";
        this.mouseindicator.style.top = evt.offsetY + "px";
    }
}
//# sourceMappingURL=measuremodehandler.js.map